/* Fallback for prices of 0.00 (RRP not set) in places the FalcX snippets don't render, such as Horizon's predictive
   search results: "$0.00" or "Free" becomes "Price coming soon". FalcX cards and the product page handle this
   server-side; this only touches price elements whose whole text is a zero price. */
(function () {
  'use strict';
  /* r9 (pdp): run once per page. falcx-head (and with it this file) is printed by many sections, and every run used to
     add another page-wide MutationObserver (14 on the home page). */
  if (typeof window === 'undefined' || window.__falcxPriceInit) return;
  window.__falcxPriceInit = true;
  var ZERO = /^(from\s+)?(\$\s?0(\.00)?(\s?aud)?|free)$/i;
  /* Only product listings: cards, search results, recommendations. Never the cart, where $0.00 is a real total. */
  var SCOPE = 'product-card, .resource-card, predictive-search-component, .predictive-search, product-recommendations, .product-recommendations';
  var SELECTOR = 'product-price, .price, [class*="price"]';
  function fix(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.falcxPriceSoon !== undefined || el.children.length > 2) return;
      if (!el.closest(SCOPE) || el.closest('cart-drawer, cart-items-component, .cart-drawer, .cart-items, form[action*="/cart"]')) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!ZERO.test(text)) return;
      el.dataset.falcxPriceSoon = '';
      el.textContent = 'Price coming soon';
      el.classList.add('falcx-price-soon');
    });
  }
  function init() {
    fix(document.body);
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fix(document.body); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
